import { SearchIcon } from '@chakra-ui/icons';
import {
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spinner,
  useDisclosure,
  Text,
} from '@chakra-ui/react';
import { useState, useRef, useEffect, useMemo } from 'react';
import { FixedSizeList } from 'react-window';
import { useSelector } from 'react-redux';

import { STATUS } from 'projectConstants';
import { getDashboardBlocks, getDashboardBlockStatus } from 'redux/DashboardSliceV2';
import FigmaTriangleDown from 'components/Icons/FigmaTriangleDown';

export interface Properties {
  blockId: number;
  handleBlockChange: (block: any) => void;
}
const ModalBlock = ({ blockId, handleBlockChange }: Properties) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const blockDetails = useSelector(getDashboardBlocks);
  const getBlockStatus = useSelector(getDashboardBlockStatus);
  const [searchValue, setSearchValue] = useState('');
  const inputReference: any = useRef(null);
  const itemHeight = 30;
  const [listData, setListData] = useState(blockDetails);
  const calculatedHeight = listData.length * itemHeight;
  const height = Math.min(calculatedHeight, 150);
  const width = 260;

  const selectedBlock = useMemo(() => {
    if (blockId) {
      const blockData = blockDetails?.find((item: any) => item.block_id === blockId);
      return blockData.block_name;
    }
    return null;
  }, [blockId, blockDetails]);

  useEffect(() => {
    if (blockDetails) {
      setListData(blockDetails);
    }
  }, [blockDetails]);

  const handleSearch = (value: string) => {
    setListData(
      blockDetails.filter((item: any) =>
        item.blockName?.toLowerCase().includes(searchValue?.toLowerCase()),
      ),
    );
    setSearchValue(value);
  };

  const blockChange = (block: any) => {
    handleBlockChange(block);
    onClose();
  };

  const Row = (properties: any) => {
    const { index, style, data } = properties;
    return (
      <Flex
        alignItems={'center'}
        bg='white'
        mb='1px'
        px='11px'
        fontFamily='Roboto Regular'
        fontSize='13px'
        color='#121826'
        _hover={{ backgroundColor: '#F5F5F5' }}
        onClick={() => {
          blockChange(data[index]);
        }}
        style={style}
        cursor={'pointer'}
      >
        {data[index].block_name}
      </Flex>
    );
  };

  return (
    <Flex flexDir={'column'} gap='4px'>
      <Text fontFamily='Roboto Bold' fontWeight='600' fontSize='13px' color='#121826'>
        Block
      </Text>
      <Menu isOpen={isOpen} onClose={onClose} strategy='fixed' isLazy matchWidth>
        <MenuButton width={'100%'} onClick={isOpen ? onClose : onOpen}>
          <Flex
            justifyContent={'space-between'}
            alignItems={'center'}
            backgroundColor='white'
            border='1px solid #D9D9D9'
            px='11px'
            py='11px'
            borderRadius='9px'
            color={selectedBlock ? '#121826' : '#708090'}
            fontFamily='Roboto Regular'
            fontSize='13px'
          >
            <Text>{selectedBlock || 'Name here'}</Text>
            <FigmaTriangleDown width={10} height={6} color='#708090' />
          </Flex>
        </MenuButton>
        <MenuList
          p={0}
          bg='#E8E9EB'
          border='none'
          borderRadius='14px'
          overflow='hidden'
          boxShadow='0px 4px 24px rgba(0, 0, 0, 0.25)'
        >
          {getBlockStatus === STATUS.LOADING ? (
            <MenuItem bg='white' justifyContent='center'>
              <Spinner size={'md'} />
            </MenuItem>
          ) : (
            <>
              <Flex alignItems={'center'} bg='white' mb='1px' px='11px' height='40px'>
                <InputGroup>
                  <InputLeftElement
                    pointerEvents='none'
                    h='100%'
                    children={<SearchIcon width={'14px'} height={'14px'} color='#708090' />}
                  />
                  <Input
                    border='none'
                    fontFamily='Roboto Regular'
                    fontSize='13px'
                    color='#121826'
                    ref={inputReference}
                    placeholder='Search'
                    _placeholder={{ color: '#BEBEBE' }}
                    _focus={{ boxShadow: 'none' }}
                    onChange={(event: any) => {
                      handleSearch(event.target.value);
                    }}
                  />
                </InputGroup>
              </Flex>
              {blockDetails.length > 0 ? (
                <FixedSizeList
                  className='scroll'
                  height={height}
                  itemData={listData}
                  itemCount={listData.length}
                  itemSize={itemHeight}
                  width={width}
                >
                  {Row}
                </FixedSizeList>
              ) : (
                <Text bg='white' px='11px' py='9px' fontFamily='Roboto Regular' fontSize='13px'>
                  No Block Found
                </Text>
              )}
            </>
          )}
        </MenuList>
      </Menu>
    </Flex>
  );
};
export default ModalBlock;
